import React, { createContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export const ValidationContext = createContext(null);

export const ValidationProvider = ({ children }) => {
  const filtersSectionRef = useRef(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const scrollToFilters = () => {
    filtersSectionRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const value = {
    filtersSectionRef,
    isSubmitted,
    setIsSubmitted,
    scrollToFilters,
    scrollToTop
  };

  return (
    <ValidationContext.Provider value={value}>
      {children}
    </ValidationContext.Provider>
  );
};

ValidationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
